import { useAccountContext } from '../useAccountContext';

export const useSberIdWasLinked = () => {
  const { currentCompany } = useAccountContext();

  return Boolean(currentCompany?.sberIdWasLinked);
};
